/**
 * CentroDeCustoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CentroDeCusto} from '@/model/resource/CentroDeCusto'

/* TODO: review generated class */
@HttpExclude()
export class CentroDeCustoCollection extends PageCollection<CentroDeCusto> {
  constructor() {
    super(CentroDeCusto)
  }

  queryAsPage() {
    return this.listCentroDeCusto()
  }

  async listCentroDeCusto() {
    return await Request.get(`/admin/centro-de-custo`, {params: this.params})
      .name('listCentroDeCusto')
      .as(this)
      .getResponse()
  }

  async listCsvCentroDeCusto() {
    return await Request.get(`/admin/centro-de-custo/csv`, {
      params: this.params,
    })
      .name('listCsvCentroDeCusto')
      .as(this)
      .getResponse()
  }
}
